import { produce } from 'immer';

import {
  DOCUMENT_PROGRESS__BULK_EXPIRY_DATE_CHANGE_REQUEST,
  DOCUMENT_PROGRESS__BULK_REQUEST_CANCEL_REQUEST,
  DOCUMENT_PROGRESS__BULK_SIGNING_REMIND_REQUEST,
  DOCUMENT_PROGRESS__EXPIRY_DATE_CHANGE_FAILURE,
  DOCUMENT_PROGRESS__REQUEST_CANCEL_FAILURE,
  DOCUMENT_PROGRESS__SIGNING_REMIND_FAILURE,
} from '@app/store/actionTypes';
import { DocumentProgressAction } from '@app/store/documentProgress/actions';
import VisibleDocument from '@app/store/documents/VisibleDocument';

import FailedDocumentError from '../FailedDocumentError';

export type DocumentProgressFailedDocumentsState = (VisibleDocument & { errorMessage: string })[];

const initialState: DocumentProgressFailedDocumentsState = [];

export default function reducer(
  state: DocumentProgressFailedDocumentsState = initialState,
  action: DocumentProgressAction
) {
  switch (action.type) {
    case DOCUMENT_PROGRESS__BULK_EXPIRY_DATE_CHANGE_REQUEST:
    case DOCUMENT_PROGRESS__BULK_REQUEST_CANCEL_REQUEST:
    case DOCUMENT_PROGRESS__BULK_SIGNING_REMIND_REQUEST:
      return initialState;
    case DOCUMENT_PROGRESS__EXPIRY_DATE_CHANGE_FAILURE:
    case DOCUMENT_PROGRESS__REQUEST_CANCEL_FAILURE:
    case DOCUMENT_PROGRESS__SIGNING_REMIND_FAILURE: {
      return produce(state, (draft) => {
        if (action.payload instanceof FailedDocumentError) {
          draft.push({ ...action.payload.failedDocument, errorMessage: action.payload.message });
        }
      });
    }
    default:
      return state;
  }
}
